(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('psychIntakePersonalInjuryComponent', psychIntakePersonalInjuryComponent);

    psychIntakePersonalInjuryComponent.$inject = [];

    function psychIntakePersonalInjuryComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectivePsychIntakePersonalInjuryController,
            templateUrl: 'app/psych-intake/workflow/partial/directive/personal-injury.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectivePsychIntakePersonalInjuryController.$inject = ['$scope', '$stateParams', '$element'];
    function DirectivePsychIntakePersonalInjuryController($scope, $stateParams, $element) {
        var vm = this;
        
        vm.datePickerOpenStatus = {
            datePersonalInjury: false
        };

        vm.datePickerOptions = {
            maxDate: new Date()
        };

        function init() {
        }

        init();
    }
})();
